module.exports = __webpack_public_path__ + "img/icon-p-800.a5c2424b.png";